import { useAtom, useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'
import { exists } from '~/utils'

import {
  brand1IdAtom,
  brand2IdAtom,
  customerAttributeIdsAtom,
  isPendingTabulationAtom,
  questionIdsAtom,
} from '../atoms'

export type TabulateButtonProps = {
  className?: string
}

export const TabulateButton = ({ className }: TabulateButtonProps) => {
  const { t } = useTranslation()
  const logEvent = useLogEvent()

  const brand1 = useAtomValue(brand1IdAtom)
  const brand2 = useAtomValue(brand2IdAtom)
  const questionIds = useAtomValue(questionIdsAtom)
  const customerAttributeIds = useAtomValue(customerAttributeIdsAtom)
  const [isPendingTabulation, setIsPendingTabulation] = useAtom(
    isPendingTabulationAtom,
  )

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setIsPendingTabulation(false)

    logEvent('Reload data')
  }, [logEvent, setIsPendingTabulation])

  if (
    !exists(brand1) ||
    !exists(brand2) ||
    (questionIds.length === 0 && customerAttributeIds.length === 0) ||
    !isPendingTabulation
  ) {
    return null
  }

  return (
    <StyledButton
      buttonStyle="alert"
      className={className}
      onClick={handleClick}
    >
      {t('refresh_results')}
    </StyledButton>
  )
}
